import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { ColorChipAutoCompleteDetailsComponent } from './color-chip-autocomplete-details.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [ColorChipAutoCompleteDetailsComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule
  ],
  exports: [ColorChipAutoCompleteDetailsComponent] // Export to use in MainComponent
})
export class ColorChipAutoCompleteDetailsModule { }